import React, { memo, type PropsWithChildren } from 'react';
import SectionMessage, {
	type SectionMessageProps,
} from '@atlaskit/section-message/section-message';

type LimitSectionMessageProps = PropsWithChildren<{
	appearance?: SectionMessageProps['appearance'];
}>;

export const LimitSectionMessage: React.FC<LimitSectionMessageProps> = memo(
	({ appearance = 'warning', children }) => {
		return <SectionMessage appearance={appearance}>{children}</SectionMessage>;
	},
);
